import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export type InfoState = {
  nick_name: string;
  profile: string;
  state: number;
  uid: string;
  user_level: number;
  api_key_permission: boolean;
  vip_level: number;
  account_type?: string;
};

export type UserState = {
  userInfo: InfoState | null;
};

const initialState: UserState = {
  userInfo: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInfo: (state, action: PayloadAction<InfoState | null>) => {
      state.userInfo = action.payload;
    },
  },
});

export const { setUserInfo } = userSlice.actions;

export const selectUserInfo = (state: RootState) => state.user.userInfo;

export default userSlice.reducer;
